import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import {
    HeartTwoTone, TagsOutlined, LinkOutlined, AmazonOutlined,
    PlayCircleOutlined, ClockCircleOutlined, FileDoneOutlined, ApiOutlined
} from '@ant-design/icons';
import ReactJson from 'react-json-view';
import { Typography } from 'antd';

import JobsPickerTable from './JobPickerTable';

const { Title } = Typography;

class JobPicker extends Component {
    matchJobs = () => {
        const { analytics, jobs, loading } = this.props;

        if (loading || !Object.keys(jobs).length) return [];

        const res = Object.keys(jobs).map(jobId => {
            return {
                ...jobs[jobId],
                analytics: analytics[jobId],
                jobId,
            }
        });
        
        return res;
    }

    render() {
        const { loading, onOpenReport } = this.props;

        const matched = this.matchJobs();

        return (
            <div>
                <Title style={{ textAlign: 'left', margin: '10px 0 20px 0' }} level={3}>
                    Crawl Job List
                </Title>
                <JobsPickerTable data={matched} loading={loading} onOpenReport={onOpenReport} />
            </div>
        );
    }
}

export default JobPicker;